import { render, staticRenderFns } from "./CandidateInputReceiveFields.vue?vue&type=template&id=259efa66&scoped=true&"
import script from "./CandidateInputReceiveFields.vue?vue&type=script&lang=js&"
export * from "./CandidateInputReceiveFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "259efa66",
  null
  
)

export default component.exports